/*eslint-disable react/no-set-state*/
import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import {browserHistory} from 'react-router';
import {bindActionCreators} from 'redux';
import * as accountActions from '../../../actions/accountActions';
import ForgotPasswordForm from './ForgotPasswordForm';
import ForgotPasswordConfirmationPage from './ForgotPasswordConfirmationPage';
import mode from '../../../api/mode';
import * as errorMessages from '../../../constants/errorMessages';
import * as pathConstants from '../../../constants/pathConstants';
import '../../../styles/login/forgotPassword.css';

class ForgotPasswordPage extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      credentials: Object.assign({}, this.props.credentials),
      sendingEmail: false,
      formIsValid: false,
      page: 1,
      formErrors: {}
    };

    this.submitEmail = this.submitEmail.bind(this);
    this.enteringCredentials = this.enteringCredentials.bind(this);
    this.confirmFormIsValid = this.confirmFormIsValid.bind(this);
    this.googleReCaptchaCallback = this.googleReCaptchaCallback.bind(this);
    this.onCancel = this.onCancel.bind(this);
  }

  submitEmail(event) {
    event.preventDefault();
    this.setState({sendingEmail: true});
    this.props.actions.forgotPasswordReset(this.state.credentials.email)
      .then((response) => {
        if (response) {
          this.setState({page: 2});
        } else {
          throw(new Error("could not reset password"));
        }
      })
      .catch(error => {
        this.setState({sendingEmail: false});
        throw(error);
      });
  }
  onCancel(event) {
    event.preventDefault();
    browserHistory.push(pathConstants.pathToLogin);
  }
  enteringCredentials(event) {
    event.preventDefault();
    const field = event.target.name;
    let credentials = this.state.credentials;
    credentials[field] = event.target.value;
    this.setState({credentials: credentials});
    this.setState({
      formIsValid: this.confirmFormIsValid()
    });
  }
  googleReCaptchaCallback(key) {
    let credentials = this.state.credentials;
    credentials.googleCaptcha = key;
    this.setState({credentials: credentials});
    this.setState({
      formIsValid: this.confirmFormIsValid()
    });
  }
  confirmFormIsValid() {
    let errors = {};
    let formIsValid = true;
    const credentials = this.state.credentials;

    if (!credentials.email) {
      errors.email = errorMessages.ERROR_LOGIN_NO_USERNAME;
      formIsValid = false;
    }
    if (!credentials.googleCaptcha && this.props.userGoogleCaptcha) {
      formIsValid = false;
    }
    this.setState({formErrors: errors});
    return formIsValid;
  }

  render() {
    return (
      <div className="forgot-password">
        {this.state.page == 1 && <ForgotPasswordForm
          onChange={this.enteringCredentials}
          onSubmit={this.submitEmail}
          onCancel={this.onCancel}
          sendingEmail={this.state.sendingEmail}
          reCaptchaCallback={this.googleReCaptchaCallback}
          formErrors={this.state.formErrors}
          submitStatus={this.state.formIsValid}/>}
        {this.state.page == 2 && <ForgotPasswordConfirmationPage 
        email={this.state.credentials.email}/>}
      </div>
    );
  }
}

ForgotPasswordPage.propTypes = {
  actions: PropTypes.object.isRequired,
  credentials: PropTypes.object.isRequired,
  userGoogleCaptcha: PropTypes.bool.isRequired,
  errors: PropTypes.array.isRequired
};

function mapStateToProps(state) {

  let errors = [];

  let credentials = {
    email: ''
  };
  let userGoogleCaptcha = true;
  const currentLocation = window ? window.location.host : null;
  if (!mode.prod && currentLocation !== 'test.osha.gov' && 
      currentLocation !== 'www.osha.gov') {
    userGoogleCaptcha = false;
  }
  if (state.errors && state.errors.length > 0) {
    errors = state.errors;
  }
  return {credentials, userGoogleCaptcha, errors};
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(accountActions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPasswordPage);



/** WEBPACK FOOTER **
 ** ./src/components/authentication/ForgotPassword/ForgotPasswordPage.js
 **/